// All activity prototypes stay under /demo-* and use isolated fake data.
const journey = () =>
  import(
    /* webpackChunkName: "activity-demo-buddy-journey" */ '@/activities-demo/buddy-mission/pages.vue'
  );
const meta = {
  activityDemo: true,
  needLogin: false,
  noindex: true,
  title: '雙11・再約一次 · 活動 Demo',
};
export default [
  {
    path: '/demo-buddy-mission',
    name: 'demo-buddy-mission',
    component: () =>
      import(
        /* webpackChunkName: "activity-demo-buddy-mission" */ '@/activities-demo/buddy-mission/index.vue'
      ),
    meta,
  },
  ...[
    ['player/:buddyId', 'profile'],
    ['task/:taskId', 'task'],
    ['chat/:buddyId', 'chat'],
    ['checkout/:buddyId', 'checkout'],
    ['orders', 'orders'],
    ['order/:orderId', 'order'],
    ['coupon', 'coupon'],
    ['memory', 'memory'],
    ['progress', 'progress'],
  ].map(([path, view]) => ({
    path: '/demo-buddy-mission/' + path,
    name: 'demo-buddy-mission-' + view,
    component: journey,
    props: { view },
    meta,
  })),
];
